import { Component, HostListener, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { User } from '@core/model/user.model'
import { AuthService } from '@core/service/auth.service'
import { EnvService } from '@envs/env-service'
import { environment } from '@envs/environment'
import { HeaderStyleService, HIDE_HEADER } from '@shared/services/header-style.service'
import { ParentChildService } from '@shared/services/parent-child.service'
import { authorisedAsChildCompany, untilDestroyed } from '@shared/utils/utils'
import { UserRoleLevel } from '@core/model/enums/user-role-level.enum'
import _ from 'lodash'
import { Store } from '@ngrx/store'
import { CompanyManagementSelectors } from '../../store/selectors/company-management.selectors'
import { Observable } from 'rxjs'

@Component({ selector: 'manage', templateUrl: './manage.component.html', styleUrls: ['./manage.component.scss'] })
export class ManageComponent implements OnInit {
  baseJsUrl: string
  loggedInUser!: User
  groupId$: Observable<number>
  private readonly destroy$ = untilDestroyed()

  constructor(
    private store$: Store,
    private headerStyleService: HeaderStyleService,
    private envService: EnvService,
    private router: Router,
    public route: ActivatedRoute,
    private titleService: Title,
    private authService: AuthService,
    public parentChildService: ParentChildService
  ) {
    this.loggedInUser = this.authService.loggedInUser
    this.groupId$ = this.store$.select(CompanyManagementSelectors.selectGroupId)
  }

  ngOnInit() {
    this.headerStyleService.setHeaderClass(null)
    this.route.queryParams.pipe(this.destroy$()).subscribe((params) => {
      const tab = params['tab']
      this.baseJsUrl = `${this.envService.baseJsUrl}/admin?host=${environment.baseHost}&childCompany=${this.loggedInUser.company.id}${tab ? '&tab=' + tab : ''}`
    })
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data === 'hideHeader') {
      this.headerStyleService.setHeaderClass(HIDE_HEADER)
    } else if (event.data === 'showHeader') {
      this.headerStyleService.setHeaderClass(null)
    } else if (event.data.action === 'goToAccountSettings') {
      this.router.navigate([`/account-setup/${event.data.id}`], {
        relativeTo: this.route,
        queryParams: { tab: 'details' },
      })
    } else if (event.data.action === 'redirectToOauth2') {
      window.open(event.data.redirectUrl, '_self')
    }
  }

  retrieveTabParams(tab: string): Params {
    switch (tab) {
      case 'output':
        return { tab: tab, type: 'document' }
      default:
        return { tab: tab }
    }
  }

  onSelect($event: string) {
    this.titleService.setTitle(_.startCase(_.camelCase($event)) + ' | Admin | Scope')
    this.baseJsUrl = `${this.envService.baseJsUrl}/admin?host=${environment.baseHost}&childCompany=${this.loggedInUser.company.id}&tab=${$event}`
    const params: Params = this.retrieveTabParams($event)
    this.router.navigate([], { relativeTo: this.route, queryParams: params })
  }

  protected readonly authorisedAsChildCompany = authorisedAsChildCompany
  protected readonly UserRoleLevel = UserRoleLevel
  protected readonly parseInt = parseInt
}
